module.exports = __webpack_public_path__ + "img/fi.7c9555e6.svg";